"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsLocatableByPosition = IsLocatableByPosition;
function IsLocatableByPosition(object) {
    return 'getLatLon' in object;
}
